export default __webpack_public_path__ + "static/media/logo.a1707b59.png";